module.exports = __webpack_public_path__ + "img/question.2bec9846.svg";